require('./style.scss');

export default (translate, name, send) => {
    const modalNameElement = () => document.body.querySelector('.modal-input-name');

    const onSubmit = (e) => {
        e.preventDefault();

        const name = getName(e);

        if (!name.replace(/ /g, "").length) {
            return addErroMsg(`${translate('EMPTY_NAME')}`, modalNameElement());
        }

        send(e, {name})
    }

    const clearErroMsg = () => {
        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.add('hidden');
        errValidationPhoneMsg.innerHTML = '';
    }

    const resetErrorColor = (msg, el) => {
        modalPhoneElement().classList.remove(errorColor);
        modalEmailElement().classList.remove(errorColor);
        modalNameElement().classList.remove(errorColor);
    }

    const setErrorColor = (el) => {
        el.classList.add(errorColor);
    }

    const addErroMsg = (msg, el) => {
        resetErrorColor();
        setErrorColor(el);

        const errValidationPhoneContainer = document.body.querySelector('.err-validation-phone-container');
        const errValidationPhoneMsg = document.body.querySelector('.err-validation-phone-msg');

        errValidationPhoneContainer.classList.remove('hidden');
        errValidationPhoneMsg.innerHTML = msg;
    }

    const getName = () => {
        return modalNameElement().value;
    }

    const container = document.createElement('div');
    container.classList.add('modal-container');

    const body = document.createElement('div');
    body.classList.add('rename-thumbnails');
    const span = document.createElement('span');
    span.classList.add('rename-thumbnails-label');

    const form = document.createElement('form');
    const pText = document.createElement('p');
    pText.innerText = translate('CHANGE_NAME');

    const pInput = document.createElement('div');
    pInput.classList.add('modal-container');

    const containerName = document.createElement('div');
    containerName.classList.add('iti');
    containerName.classList.add('iiti--allow-dropdown');

    const inputName = document.createElement('input');
    inputName.type = 'text';
    inputName.value = name;
    inputName.placeholder = translate('Name');
    inputName.classList.add('modal-input');
    inputName.classList.add('modal-input-name');
    containerName.appendChild(inputName);

    pInput.appendChild(containerName);

    const submit = document.createElement('button');
    submit.classList.add('check-password-submit');
    submit.classList.add('button');
    submit.type = 'submit';
    submit.value = translate('RENAME');
    submit.innerHTML = translate('RENAME');
    form.onsubmit = onSubmit;
    pInput.appendChild(submit);

    form.appendChild(pText);
    form.appendChild(pInput);

    body.appendChild(span);
    body.appendChild(form);
    container.appendChild(body);

    return container;
}
